import React from "react";
import { IAddProject, IProjectId } from "../../Project.props";
import { useForm } from "react-hook-form";
import useEditProject from "./useEditProject";
import { CancelButton, FormButton } from "../../../../../components/Button";
import Loader from "../../../../../components/Loader";
import {
  FormFieldset,
  Input,
} from "../../../../../components/Form";

const EditProject: React.FC<IProjectId> = ({ projectId , setMethod}) => {
  const {
    loading,
    formData,
    handleChange,
    handleSubmit,
  } = useEditProject(projectId , setMethod);

  const { handleSubmit: useFormSubmit } = useForm<IAddProject>();

  const personalFields = [
    { label: "Project Name", name: "name", type: "text" },
    { label: "Description", name: "description", type: "text" },
    { label: "Git Link", name: "gitfeld", type: "text" },
  ] as const;
  return (
    <div className="flex flex-col items-center w-full h-full pr-8 pl-6 ">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full ">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-fontBlack ml-5">Edit Project</h1>
        </div>
        {loading && <Loader />}
        <form
          onSubmit={useFormSubmit(handleSubmit)}
          className="space-y-6 p-6 h-[75vh] overflow-y-scroll"
        >
          <FormFieldset Ftitle="Personal details">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 m-4">
              {personalFields.map((field) => (
                <Input
                  key={field.name}
                  name={field.name}
                  label={field.label}
                  type={field.type}
                  value={formData[field.name]}
                  onChange={handleChange}
                  required
                />
              ))}
              <div className="flex flex-col gap-1">
                <label
                  htmlFor="status"
                  className="text-sm font-medium text-gray-700"
                >
                  Status
                </label>
                <select
                  id="status"
                  name="status"
                  value={formData.status ?? "Active"}
                  onChange={handleChange}
                  className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-2"
                >
                  <option value="Active">Active</option>
                  <option value="InActive">Inactive</option>
                </select>
              </div>
            </div>
          </FormFieldset>
          <div className="flex justify-center mt-6 ml-2 gap-3">
            <CancelButton
              className="py-2 px-4 h-[56px] w-[200.5px]"
              onClick={() => setMethod?.()}
              children="Cancel"
              type="button"
            />
            <FormButton
              className="py-2 px-4  h-[56px] w-[200.5px]"
              type="submit"
              children="ADD"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProject;
